// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"style_headerWrapper__1D7ya","list":"style_list__Mqphc","additionalText":"style_additionalText__UxRuo"};